import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromAuthors from './authors.reducer';
import {AuthorsState} from './authors.reducer';
import {selectActiveCourse} from './selectors';


export const authorsState = createFeatureSelector<AuthorsState>('authors');

export const selectAllCourseAuthors = createSelector(authorsState, fromAuthors.selectAll);

export const selectActiveCourseAuthors = createSelector(
  selectActiveCourse,
  selectAllCourseAuthors,
  (activeCourse, allAuthors) => {
    const courseAuthorIds = activeCourse?.authors || [];

    const activeCourseAuthors = [];

    for (let authorId of courseAuthorIds) {

      const author = allAuthors.find(author => author.id == authorId);

      if (author) {
        activeCourseAuthors.push(author);
      }

    }

    console.log(activeCourseAuthors);

    return activeCourseAuthors;
  }
);

export const isAuthorsLoaded = createSelector(
  authorsState,
  state => state.authorsLoaded
);
